import { render, staticRenderFns } from "./NamingSkusLink.vue?vue&type=template&id=a46f064e&"
import script from "./NamingSkusLink.vue?vue&type=script&lang=js&"
export * from "./NamingSkusLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports